<template>
    <div class="video-area1">
        <InfoArea/>
        <div class="video-container">
            <video
                v-on:click="playerToggle"
                ref="player"
                preload="metadata"
                @play="monitorPlay"
                @pause="monitorPause"
                @timeupdate="monitorTime"
                @loadedmetadata="monitorLoadMetaData"
                @canplay="monitorCanPlay"
                @canplaythrough="monitorCanPlayThrough"
                @progress="monitorProgress"
                :src="url"/>
        </div>
        <HelpArea ref="helpArea"/>
    </div>
</template>

<script>
 import EventBus from '../event/event-bus.js';
 import HelpArea from "./HelpArea.vue"
 import InfoArea from "./InfoArea.vue"

 import { mapGetters } from 'vuex'
 import { notifySuccess, notifyWarning } from "../util/notify.js"
 import { mouseSeekVideo } from "../event/input.js"

 import message from "ant-design-vue/lib/message";

 export default {
     name: 'Video',
     props: {
     },
     data() {
         return {
             url: "",
             canPlayThrough: false,
             playBeforeReady: false,
         }
     },
     components: {
         InfoArea,
         HelpArea
     },
     computed: {
         ...mapGetters([
             "playerIsPlaying"
         ])
     },
     created() {
         console.log("Create Video")
     },
     mounted() {
         console.log("Mount Video")
         this.observeHelpAreaHeight();

         /* 同步视频的倍率 */
         this.syncRate()

         EventBus.$on("playerFullPlay", this.playerFullPlay);
         EventBus.$on("playerPlay", this.playerPlay);
         EventBus.$on("playerPause", this.playerPause);
         EventBus.$on("playerToggle", this.playerToggle);
         EventBus.$on("playerSeek", this.playerSeek);
         EventBus.$on("seekBackward", this.seekBackward);
         EventBus.$on("seekForward", this.seekForward);
         EventBus.$on("replayVideo", this.replayVideo);
         EventBus.$on("incrementPlaybackRate", this.incrementPlaybackRate);
         EventBus.$on("decrementPlaybackRate", this.decrementPlaybackRate);

         this.$refs.player.addEventListener("mousewheel", mouseSeekVideo)
     },
     beforeDestroy() {
        EventBus.$off("playerFullPlay");
         EventBus.$off("playerPlay");
         EventBus.$off("playerPause");
         EventBus.$off("playerToggle");
         EventBus.$off("playerSeek");
         EventBus.$off("seekBackward");
         EventBus.$off("seekForward");
         EventBus.$off("replayVideo");
         EventBus.$off("incrementPlaybackRate");
         EventBus.$off("decrementPlaybackRate");
     },
     watch: {
         '$store.state.currentRate': {
             handler: function(newer, ) {
                 this.$refs.player.playbackRate = newer
             },
             deep: true
         },
         '$store.state.orderVideoUrl': {
             handler: function(newer, ) {
                 this.url = newer
             },
             deep: true
         },
     },
     methods: {
        observeHelpAreaHeight() {
            const helpArea = this.$refs.helpArea; // 获取 HelpArea 的引用
            if (helpArea && helpArea.$el instanceof Element) { // 确保 helpArea.$el 是 DOM 元素
                const observer = new ResizeObserver(() => {
                    const helpAreaHeight = helpArea.$el.offsetHeight; // 获取 HelpArea 的实际高度
                    this.$el.style.setProperty('--help-area-height', `${helpAreaHeight}px`); // 动态设置 CSS 变量
                });
                observer.observe(helpArea.$el); // 监听 HelpArea 的根元素
            } else {
                // 如果 DOM 元素未准备好，延迟重试
                setTimeout(() => {
                    this.observeHelpAreaHeight();
                }, 500); // 100ms 后重试
            }
        },
         syncRate() {
             this.$refs.player.playbackRate = this.$store.getters.playerCurrentRate

             console.log("****** sync rate: ", this.$refs.player, this.$refs.player.playbackRate, this.$store.getters.playerCurrentRate)
         },
         monitorPlay() {
             this.$store.commit("playerPlay")
         },
         monitorPause() {
             this.$store.commit("playerPause")
         },
         monitorCanPlay() {
         },
         monitorProgress(video) {
             EventBus.$emit("downloadProgress", parseInt(video.target.buffered.end(0) * 100.0 / video.target.duration))
         },
         monitorCanPlayThrough() {
             this.canPlayThrough = true

             if (this.playBeforeReady) {
                 this.playBeforeReady = false

                 /* Destroy old message before show new message */
                 message.destroy()
                 message.success("视频缓冲好了，开始播放")

                 this.playerPlay()
             }
         },
         monitorLoadMetaData() {
             EventBus.$emit("playerProgress", this.$refs.player.duration, 0)
         },
         monitorTime() {
             EventBus.$emit("playerProgress", this.$refs.player.duration, this.$refs.player.currentTime)
         },
         playerFullPlay() {
            if (this.url != "") {
                 if (this.canPlayThrough) {
                    if (!document.fullscreenElement) {
                        const video = this.$refs.player;
                        if (video.requestFullscreen) {
                            video.requestFullscreen();
                        } else if (video.webkitRequestFullscreen) {
                            video.webkitRequestFullscreen(); // Safari
                        }
                    } else {
                        if (document.exitFullscreen) {
                            document.exitFullscreen();
                        } else if (document.webkitExitFullscreen) {
                            document.webkitExitFullscreen(); // Safari
                        }
                    }
                 }
            }
            
        },
         playerPlay() {
             if (this.url != "") {
                 if (this.canPlayThrough) {
                   if (this.$refs.player.currentTime == 0 || this.$refs.player.ended) {
                      this.$refs.player.load()
                      this.syncRate()
                      this.$refs.player.currentTime = 0.03
                     console.log("load");
                   }
                   console.log("play sync rate2：", this.$refs.player, this.$refs.player.playbackRate);
                   let playPromise =this.$refs.player.play()
                   if (playPromise !== undefined) {
                     playPromise.then(() => {
                       this.$refs.player.play()
                       console.log("play ok");
                     }).catch((e)=> {
                       console.log("play catch:", e);
                     })
                   }

                 } else {
                     this.playBeforeReady = true

                     /* Destroy old message before show new message */
                     message.destroy()
                     message.error("视频还在缓冲中，请稍后点击播放。")
                 }
             } else {
                 console.log("没有视频")
             }
         },
         playerPause() {
             this.$refs.player.pause()
         },
         playerToggle() {
             if (this.playerIsPlaying) {
                 this.playerPause()
             } else {
                 this.playerPlay()
             }
         },
         playerSeek(value) {
             this.playerPause()
             this.$refs.player.currentTime = this.$refs.player.duration * value / 100.0
         },
         seekForward(step) {
             this.playerPause()
             this.$refs.player.currentTime = this.$refs.player.currentTime + step
         },
         seekBackward(step) {
             this.playerPause()
             this.$refs.player.currentTime = this.$refs.player.currentTime - step
         },
         replayVideo() {
             this.$refs.player.currentTime = 0
             this.playerPlay()
         },
         incrementPlaybackRate() {
             var currentRate = this.$store.getters.playerCurrentRate
             var rateOptions = this.$store.getters.playerRateOptions.map((e) => e.value)
             var currentIndex = rateOptions.indexOf(currentRate)

             if (currentIndex >= rateOptions.length - 1) {
                 notifyWarning(
                     "倍数调节",
                     "已经调至最大倍数: " + currentRate + "倍"
                 )
             } else {
                 var newRate = rateOptions[currentIndex + 1]

                 this.$store.commit("playerChangeRate", newRate)

                 notifySuccess(
                     "倍数调节",
                     "已经将播放速度增大至" + newRate + "倍"
                 )
             }
         },
         decrementPlaybackRate() {
             var currentRate = this.$store.getters.playerCurrentRate
             var rateOptions = this.$store.getters.playerRateOptions.map((e) => e.value)
             var currentIndex = rateOptions.indexOf(currentRate)

             if (currentIndex <= 0) {
                 notifyWarning(
                     "倍数调节",
                     "已经调至最小倍数: " + currentRate + "倍"
                 )
             } else {
                 var newRate = rateOptions[currentIndex - 1]

                 this.$store.commit("playerChangeRate", newRate)

                 notifySuccess(
                     "倍数调节",
                     "已经将播放速度减小到" + newRate + "倍"
                 )
             }
         },
     }
 }
</script>

<style scoped>
 .video-area1 {
    display: flex;
    flex-direction: column;
    height: calc(100% - 44px);
    background: black;
}

 .video-container {
    background: black;
    width: 100%;
    font-size: 0;
    flex-grow: 1; 
    flex-shrink: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden; /* 防止内容溢出 */
    height: calc(100% - 100px - var(--help-area-height));
}

 /* .video-container:before {
     content: "";
     width: 1px;
     height: 100%;
     display: inline-block;
     vertical-align: middle;
     margin-left: -1px;
 } */

 .video-container video {
     max-width: 100%;
     max-height: 100%;
     display: inline-block;
     vertical-align: middle;
 }
</style>
